import React, { useEffect } from 'react';
import UpdateUnsubscribePage from 'scenes/UpdateUnsubscribe/UpdateUnsubscribePage';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { default as PrivateRoute } from 'PrivateRoute';
import { default as AdminPrivateRoute } from 'AdminPrivateRoute';
import ReactNotification from 'react-notifications-component';
import { GlobalStyles, ScrollToTop } from 'utils';
import 'antd/dist/antd.css';
import Analytics from 'react-router-ga';

// import { add, init, track } from '@amplitude/analytics-browser';
// import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';

import {
  ProjectFormPage,
  ProjectFormV2,
  HowItWorksPage,
  AboutUsPage,
  ProfilePage,
  MyProjectDetailsPage,
  ResetPasswordPage,
  ThankYouStartProject,
  LoginPage,
  ThankYouPage,
  SingUp,
  Datenschutz,
  Impressum,
  ANB,
  Fees,
  Legitimation,
  TransparencyAndTrustPage,
  ContactUsPage,
  Guidelines,
  FAQs,
  WelcomePage,
  CancelPage,
  SuccessPage,
  AdminLoginPage,
  AllProjects,
  SelectHomeProject,
  ViewProject,
  NewsletterPage,
  InvoicesPage,
  AddFundingDaysPage,
  CreateDraftPage,
  BookedGoodiesPage,
  AdminSettingsPage,
  AllDonations,
  ViewDonationDetails,
  AllCategory,
  DraftSubmitted,
  SelectPriorityProject,
  AdminReconnect,
  AdminTransfer,
  AdminConnectAccounts,
} from 'scenes';
import 'utils/fetchIntercept';
import CompletionScreen from 'scenes/CompletionScreen/CompletionScreen';
import PaymentPage from 'scenes/Donation/PaymentPage';
// import DonationPage from 'scenes/Donation/DonationPage';
// import ProjectPageTest from 'scenes/Project/ProjectPageTest';
import ProjectPage from 'scenes/Project/v2/ProjectPage';
import RecurringPayments from 'scenes/RecurringPayments/RecurringPayments';
import AdminRecurringPayments from 'scenes/AdminRecurringPayments/AdminRecurringPayments';
import ParticipantPage from 'scenes/ParticipantPage/ParticipantPage';
import ProjectCategoryView from 'scenes/ProjectCategoryView/ProjectCategoryView';
import ThankYouPageTicket from 'scenes/ThankYou/ThankYouPageTicket';
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';
import LoggedInRoute, { ProtectedRoute } from 'components/Protected';
import Locked from 'scenes/locked';
//import EventsPage from 'scenes/Projects/EventsPage';
import { isAuthenticated } from 'utils/Authentication';
import './scenes/Project/components/project_details.css';
import './App.css';
import { GoogleOAuthProvider } from '@react-oauth/google';
import Ramzan from 'scenes/RamzamPage/Ramzan';
import Ramzan26 from 'scenes/RamzamPage26/Ramzan';
import Freitag from 'scenes/FreitagPage/Freitag';
import FreitagCheckout from 'scenes/FreitagPage/FreitagCheckout';
import FreitagEmbed from 'scenes/FreitagPage/FreitagEmbed';
import Dh25 from 'scenes/Dh25/Dh25';
import { useLocation, useParams } from 'react-router-dom/cjs/react-router-dom';
import { disableFbq, enableFbq, loadFbq } from 'fbq';
import PromotionManagement from './scenes/PromotionManagement';
import dhullhijjah2026Embed from 'scenes/RamzamPage26/dhullhijjah2026Embed';
import DonationV2Page from './scenes/Donation/DonationV2/DonationV2Page';
import EmbedShareWidget from './scenes/Project/Widget/EmbeddedWidget';
import PaymentReturnPage from './scenes/PaymentReturn/PaymentReturnPage';

// import { add, init, track } from '@amplitude/analytics-browser';
// import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';

// const AMPLITUDE_API_KEY = 'e866d2f4ce86c5b0144b8f9cfa798cc1';

// const sessionReplayTracking = sessionReplayPlugin({
//   debugMode: true,
// });
// add(sessionReplayTracking);
// init(AMPLITUDE_API_KEY, {
//   defaultTracking: { sessions: true },
//   autocapture: { sessions: true },
// });

const ExternalRedirect = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '20px', fontSize: '18px' }}>
      In Production and Testing, Home and Projects paths are handled by a proxy
      server. If you're seeing this, please refresh the page or contact support.
    </div>
  );
};

const CategoryRedirect = () => {
  const location = useLocation();

  useEffect(() => {
    fetch(location.pathname.replace('/', ''), {
      method: 'GET',
      headers: {
        'X-Category-Route': 'true',
      },
    })
      .then((response) => {
        console.log('Response received:', response);
      })
      .catch((error) => {
        console.error('Error sending GET request:', error);
      });
  }, [location.pathname]);

  return (
    <div style={{ textAlign: 'center', marginTop: '20px', fontSize: '18px' }}>
      In Production and Testing, Category paths are handled by a proxy server.
      If you're seeing this, please refresh the page or contact support.
    </div>
  );
};

const FreitagProjectRedirect = ({ location }) => (
  <Redirect
    to={{
      pathname: '/freitag',
      search: location.search,
    }}
  />
);

function App() {
  // useEffect(() => {
  //   track('Session Started');
  // }, []);
  // Persist all supported UTM parameters from the current URL into sessionStorage
  const searchParams = new URLSearchParams(window.location.search);
  const utmKeys = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'utm_adgroup',
    'utm_placement',
    'utm_device',
    'utm_audience',
    'utm_geo',
    'utm_creative',
    'utm_network',
    'utm_id',
  ];
  utmKeys.forEach((key) => {
    const value = searchParams.get(key);
    if (
      value !== null &&
      value !== undefined &&
      value !== 'null' &&
      value !== 'undefined' &&
      String(value).trim() !== ''
    ) {
      sessionStorage.setItem(key, value);
    }
  });

  const clientId =
    '991836439302-djjl1h90dnneuckd2borihqr1piuiitq.apps.googleusercontent.com';

  useEffect(() => {
    const path = window.location.pathname;
    const isExcluded = path.startsWith('/freitag-embed');
    if (isExcluded) {
      disableFbq();
    } else {
      loadFbq();
      enableFbq();
      if (window.fbq) window.fbq('track', 'PageView');
    }
  }, []);

  return (
    <div>
      <ReactNotification />
      <GlobalStyles />
      <Router>
        <ScrollToTop />
        <GoogleOAuthProvider clientId={clientId}>
          <Analytics id="UA-203767931-1">
            <Switch>
              <Route exact path="/" component={() => <ExternalRedirect />} />
              {/* <LoggedInRoute
                path="/projects/:category"
                component={ProjectsPage}
              /> */}
              <Route
                exact
                path="/projects"
                component={() => <ExternalRedirect />}
              />
              <LoggedInRoute
                path="/events"
                component={() => <ExternalRedirect />}
              />
              <Route
                exact
                path={['/project/freitag', '/project/freigtag']}
                component={FreitagProjectRedirect}
              />
              {/* <LowerCaseRedirectProject path="/project/:url" component={ProjectPageTest}  /> */}
              <LoggedInRoute
                exact
                path="/project/:url"
                component={ProjectPage}
              />
              <Route
                exact
                path="/project/:url/widget"
                component={EmbedShareWidget}
              />
              <LoggedInRoute
                exact
                path="/project/:id/donation"
                component={DonationV2Page}
              />
              <Route
                exact
                path="/payments/return"
                component={PaymentReturnPage}
              />
              <LoggedInRoute
                exact
                path="/payment/:id/donation"
                component={PaymentPage}
              />
              <LoggedInRoute path="/about-us" component={AboutUsPage} />
              <LoggedInRoute path="/how-it-works" component={HowItWorksPage} />
              <LoggedInRoute
                path="/reset-password"
                component={ResetPasswordPage}
              />
              <Route path="/login" component={LoginPage} />
              <Route
                exact
                path="/updates/abmelden"
                component={UpdateUnsubscribePage}
              />
              <Route path="/protected" component={Locked} />
              <Route path="/register" component={SingUp} />
              <LoggedInRoute
                exact
                path="/thank-you/:url"
                component={ThankYouPage}
              />
              <LoggedInRoute
                exact
                path="/thank-you-page"
                component={ThankYouPage}
              />
              <LoggedInRoute
                exact
                path="/submitted"
                component={DraftSubmitted}
              />
              <LoggedInRoute
                exact
                path="/events-success"
                component={ThankYouPageTicket}
              />
              <LoggedInRoute exact path="/ramadan2025" component={Ramzan} />
              {/* <LoggedInRoute exact path="/dhullhijjah2026" component={Ramzan26} /> */}
              <LoggedInRoute
                exact
                path="/dhullhijjah2026-embed"
                component={dhullhijjah2026Embed
                }
              />
              <LoggedInRoute exact path="/freitag/checkout" component={FreitagCheckout} />
              <LoggedInRoute exact path="/freitag" component={Freitag} />
              <LoggedInRoute
                exact
                path="/freitag-embed"
                component={FreitagEmbed}
              />
              <LoggedInRoute exact path="/dh25" component={Dh25} />
              <LoggedInRoute path="/welcome" component={WelcomePage} />
              <LoggedInRoute path="/datenschutz" component={Datenschutz} />
              <LoggedInRoute path="/impressum" component={Impressum} />
              <LoggedInRoute path="/anb" component={ANB} />
              <LoggedInRoute path="/fees" component={Fees} />
              <LoggedInRoute path="/legitimation" component={Legitimation} />
              <LoggedInRoute path="/completion" component={CompletionScreen} />
              <LoggedInRoute
                path="/transparency-and-trust"
                component={TransparencyAndTrustPage}
              />

              <LoggedInRoute path="/contact-us" component={ContactUsPage} />

              <LoggedInRoute path="/guidelines" component={Guidelines} />
              <LoggedInRoute path="/faqs" component={FAQs} />
              <LoggedInRoute path="/cancel" component={CancelPage} />
              <Route path="/admin/login" component={AdminLoginPage} />
              {/* <Route exact path="/start-project" component={StartProjectPage} /> */}
              {/* <ProtectedRoute
                exact
                path="/start-project"
                component={ProjectFormPage}
              /> */}
              <Route exact path="/start-project" component={ProjectFormV2} />
              <AdminPrivateRoute
                path="/admin/view-project/:id"
                component={ViewProject}
              />
              <LoggedInRoute
                exact
                path="/start-project/thankyou"
                component={ThankYouStartProject}
              />
              <LoggedInRoute
                exact
                path="/recurring-payments"
                component={RecurringPayments}
              />

              <PrivateRoute path="/profile" component={ProfilePage} />

              <AdminPrivateRoute
                path="/admin/all-projects"
                component={AllProjects}
              />

              <AdminPrivateRoute
                path="/admin/all-donations"
                component={AllDonations}
              />
              <AdminPrivateRoute
                path="/admin/all-category"
                component={AllCategory}
              />
              <AdminPrivateRoute
                path="/admin/promotions"
                component={PromotionManagement}
              />
              <AdminPrivateRoute
                path="/admin/view-donation-detail/:id"
                component={ViewDonationDetails}
              />

              <AdminPrivateRoute
                path="/admin/select-projects"
                component={SelectHomeProject}
              />

              <AdminPrivateRoute
                path="/admin/priority-projects"
                component={SelectPriorityProject}
              />

              <AdminPrivateRoute
                path="/admin/newsletter"
                component={NewsletterPage}
              />
              <AdminPrivateRoute
                path="/admin/invoices"
                component={InvoicesPage}
              />
              <AdminPrivateRoute
                path="/admin/createdraft"
                component={CreateDraftPage}
              />
              <AdminPrivateRoute
                path="/admin/addfunding"
                component={AddFundingDaysPage}
              />
              <AdminPrivateRoute
                path="/admin/participants"
                component={ParticipantPage}
              />
              <AdminPrivateRoute
                path="/admin/bookedgoodies"
                component={BookedGoodiesPage}
              />
              <AdminPrivateRoute
                path="/admin/settings"
                component={AdminSettingsPage}
              />
              {/*<AdminPrivateRoute
                path="/admin/protected/accounts"
                component={AdminConnectAccounts}
              />*/}
              <AdminPrivateRoute
                path="/admin/protected/reconnect"
                component={AdminReconnect}
              />
              {/*<AdminPrivateRoute
                path="/admin/protected/transfer"
                component={AdminTransfer}
              />*/}

              <PrivateRoute
                exact
                path="/success-project"
                component={SuccessPage}
              />
              <PrivateRoute
                exact
                path="/view/:id"
                component={ProjectPage}
              />
              {/*
              <PrivateRoute
                exact
                path="/start-project/:id"
                component={ProjectFormPage}
              /> */}
              <PrivateRoute
                exact
                path="/start-project/:id"
                component={ProjectFormV2}
              />
              <PrivateRoute
                path="/my-project/:id"
                component={MyProjectDetailsPage}
              />
              <PrivateRoute
                exact
                path="/admin/recurring-payments"
                component={AdminRecurringPayments}
              />
              <LowerCaseRedirect
                path="/event/:categoryName"
                url="/event/"
                component={ProjectCategoryView}
              />
              <LowerCaseRedirect
                path="/:categoryName"
                url="/"
                component={ProjectCategoryView}
              />
            </Switch>
          </Analytics>
        </GoogleOAuthProvider>
      </Router>
    </div>
  );
}

export default App;

const LowerCaseRedirect = ({ component: Component, url, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      if (!isAuthenticated()) return <Redirect to="/protected" />;
      const categoryName = props.match.params.categoryName;
      const lowerCaseCategoryName = categoryName.toLowerCase();

      if (categoryName !== lowerCaseCategoryName) {
        return <Redirect to={`${url}${lowerCaseCategoryName}`} />;
      }

      return <Component {...props} />;
    }}
  />
);

//const LowerCaseRedirectProject = ({ component: Component, ...rest }) => (
//  <Route
//    {...rest}
//    render={(props) => {
//      const categoryName = props.match.params.url;
//      const lowerCaseCategoryName = categoryName.toLowerCase();
//
//      if (categoryName !== lowerCaseCategoryName) {
//        return <Redirect to={`/project/${lowerCaseCategoryName}`} />;
//      }
//
//      return <Component {...props} />;
//    }}
//  />
//);
